

import React from "react";
import { useParams } from "react-router-dom";
import {
    CalendarDays,
    MapPin,
    Building2,
    Users,
    ArrowRight,
    BookOpen,
    BriefcaseBusiness,
    Monitor,
    BookMarked,
    Newspaper,
    FileText,
    GlassWater,
    Accessibility,
    RefreshCw,
    Library,
} from "lucide-react";
import { useState } from "react";


import Header from "../../components/Header";
import Footer from "../../components/Footer";

/* LIBRARY FACILITY COMPONENT */

const LibraryFacility = ({ icon, title }) => {
    return (
        <div className="group flex items-center gap-4 p-5 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300">

            <div className="shrink-0 w-11 h-11 rounded-xl bg-[#fff1ef] text-[#F04B3A] flex items-center justify-center group-hover:bg-[#F04B3A] group-hover:text-white transition-colors duration-300">
                {icon}
            </div>

            <p className="text-[15px] font-medium text-[#24364b] leading-6">
                {title}
            </p>

        </div>
    );
};


/* COLLECTION ITEM COMPONENT */

const CollectionItem = ({ label, value }) => {
    return (
        <div className="flex items-center justify-between gap-4 py-3 border-b border-white/10 last:border-0">

            <span className="text-white/75 text-sm leading-5">
                {label}
            </span>

            <span className="text-white font-gill text-sm text-right whitespace-nowrap">
                {value}
            </span>

        </div>
    );
};
const CentralLibraryPage = () => {
    return (
<div className="min-h-screen bg-[var(--paper)]">
    <Header />

    {/* HERO */}
    <section className="relative h-[300px] overflow-hidden">
        <img src="/images/campusKumaun.avif" alt="Kumaun University"
            className="absolute inset-0 w-full h-full object-cover" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#d1fae5]/95 via-[#a7f3d0]/80 to-[#ecfdf5]/40" />
        <div className="relative z-10 max-w-7xl mx-auto h-full px-4 flex items-center">
            <div className="max-w-3xl text-white">

                {/* Breadcrumb */}
                <div className="flex items-center gap-2 text-sm text-white/70 mb-2">
                    <span className="text-[#123B5D] text-lg font-gill">
                       Home
                    </span>
                      <span className="text-[#123B5D] text-lg font-gill">
                      /
                    </span>
                   <span className="text-[#123B5D] text-lg font-gill">
                        Central Library
                    </span>
                </div>

               

                <h1 className="text-4xl md:text-6xl font-bold leading-tight text-[#064E3B] font-gill">
                    CENTRAL LIBRARY
                </h1>

             
            </div>
        </div>
    </section>

    {/* STATS */}
    

    {/* ABOUT CONTENT */}
    <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">

            {/* IMAGE */}
          <div className="relative">
    <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

    <img
        src="/images/central-library.jpeg"
        alt="Central Library"
        className="relative w-full h-auto object-contain rounded-3xl shadow-xl"
    />
</div>

            {/* CONTENT */}
            <div>
                <h2 className="uppercase tracking-[0.2em] text-3xl md:text-4xl font-gill font-bold text-[var(--terracotta)] mb-3">
                   About The Library
                </h2>

                {/* <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6">
                   UNIVERSITY AT A GLANCE
                </h2> */}

                <p className="text-gray-600 leading-8 mb-5 text-justify font-gill">
                   Established in 1973, the Central Library of Kumaun University stands as the cornerstone of the institution’s academic and research ecosystem. Situated amidst the scenic university premises in Nainital, Uttarakhand. It serves as a dynamic hub for learning, teaching, research, and scholarly exchange of knowledge among students, faculty members, researchers, and other members of the University community.
                </p>
                 <p className="text-gray-600 leading-8 mb-5 text-justify font-gill">
                   The library is committed to providing users with timely and quality access to a wide range of information resources in print as well as electronic formats. Its collection encompasses books, reference materials, journals, periodicals, research publications, theses and dissertations, and other scholarly resources covering diverse disciplines.
                </p>
                 <p className="text-gray-600 leading-8 mb-5 text-justify font-gill">
                   On November 24, 2023, Kumaun University officially renamed the Central Library in honour of Maha Vir Chakra awardee Martyr Major Rajesh Adhikari. An esteemed alumnus of the DSB Campus, Major Adhikari made the supreme sacrifice during the 1999 Kargil War. The renaming commemorates his valour, patriotism, and enduring legacy, inspiring future generations of students and scholars.
                </p>
                

              
            </div>

        </div>
    </section>
    {/* card section add vision of library start  */}
    {/* VISION & OBJECTIVES */}
<section className="py-12 px-6 bg-[var(--paper)]">
    <div className="max-w-7xl mx-auto">

        <div className="grid lg:grid-cols-2 gap-8">

            {/* VISION CARD */}
            <div className="bg-[#066c53] rounded-lg p-8 md:p-10 shadow-lg">

                <h2 className="text-3xl font-bold text-white mb-6 font-gill">
                    Vision of the Library
                </h2>

                <ul className="space-y-4 text-white text-[16px] leading-7">

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="font-gill">
                            To serve as a knowledge hub of the University.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="font-gill">
                            To inculcate reading habits among the students and teaching community.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="font-gill">
                            To help rural students to enrich their knowledge to create better world for themselves.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="font-gill">
                            Central Library is moving from print to electronic medium (i.e books &amp; e journals).
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="font-gill">
                            Library is moving towards fully automated (RFID).
                        </span>
                    </li>

                </ul>
            </div>


            {/* OBJECTIVES CARD */}
            <div className="bg-[#043465] rounded-lg p-8 md:p-10 shadow-lg">

                <h2 className="text-3xl font-bold text-white mb-6 font-gill">
                    Objectives of the Library
                </h2>

                <ul className="space-y-4 text-white text-[16px] leading-7">

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="text-lg font-gill">
                            Cultivate reading habits among students and teaching community.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="text-lg font-gill">
                            Provide accessibility to information in a well organized and coherent manner.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="text-lg font-gill">
                            Provide facilities and services for teaching community and students to discover needed information and use them according to their needs.
                        </span>
                    </li>

                    <li className="flex items-start gap-3">
                        <span className="text-[#F04B3A] font-bold text-xl leading-7">
                            »
                        </span>
                        <span className="text-lg font-gill">
                            Develop an efficient and effective library which is adaptable to the changing academic environment.
                        </span>
                    </li>

                </ul>
            </div>

        </div>

    </div>
</section>
    {/* card section add vision of library end  */}
{/* layout section start */}
{/* LIBRARY LAYOUT & COLLECTION */}
<section className="py-20 px-6 bg-[#f5f7fa]">
    <div className="max-w-7xl mx-auto">

        {/* SECTION HEADER */}
        <div className="mb-12">
            {/* <p className="uppercase tracking-[0.2em] text-sm font-bold text-[var(--terracotta)] mb-3">
                Library Facilities
            </p> */}

            <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] font-gill">
                Layout of Library
            </h2>

            <p className="mt-4 text-gray-600 max-w-3xl leading-7 text-lg font-gill">
               The Central Library Building is located in the vicinity of Kumaun University admin block.
            </p>
        </div>


        {/* MAIN GRID */}
        <div className="grid lg:grid-cols-3 gap-8">

            {/* ================= FACILITIES ================= */}
            <div className="lg:col-span-2">

                <div className="grid sm:grid-cols-2 gap-5">

                    {/* FACILITY CARD */}
                    <LibraryFacility
                        icon={<Building2 size={22} />}
                        title="Librarian Office"
                    />

                    <LibraryFacility
                        icon={<BookOpen size={22} />}
                        title="Reference Section"
                    />

                    <LibraryFacility
                        icon={<BriefcaseBusiness size={22} />}
                        title="Baggage Counter"
                    />

                    <LibraryFacility
                        icon={<Monitor size={22} />}
                        title="Internet Centre for Students & Faculty"
                    />

                    <LibraryFacility
                        icon={<Users size={22} />}
                        title="Log-In / Log-Out for Students & Faculty"
                    />

                    <LibraryFacility
                        icon={<BookMarked size={22} />}
                        title="Periodical Section: Journals / Magazines (27)"
                    />

                    <LibraryFacility
                        icon={<Newspaper size={22} />}
                        title="Display of New Arrivals"
                    />

                    <LibraryFacility
                        icon={<FileText size={22} />}
                        title="Newspapers Section (04)"
                    />

                    <LibraryFacility
                        icon={<GlassWater size={22} />}
                        title="Drinking Water (RO Purifier)"
                    />

                    <LibraryFacility
                        icon={<Accessibility size={22} />}
                        title="Toilet for Staff / Users"
                    />

                    <LibraryFacility
                        icon={<RefreshCw size={22} />}
                        title="Automated Circulation Counter"
                    />

                </div>
            </div>


            {/* ================= COLLECTION CARD ================= */}
            <div>
                <div className="relative overflow-hidden rounded-3xl bg-[#082F55] p-7 md:p-8 shadow-xl">

                    {/* Decorative circle */}
                    <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-white/5" />

                    <div className="relative">

                        <div className="flex items-center gap-3 mb-7">
                            <div className="w-11 h-11 rounded-xl bg-[#F04B3A] flex items-center justify-center text-white">
                                <Library size={23} />
                            </div>

                            <div>
                                <p className="text-white/60 text-sm font-gill">
                                    Library Resources
                                </p>

                                <h3 className="text-2xl font-bold text-white font-gill">
                                    Total Collection
                                </h3>
                            </div>
                        </div>


                        <div className="space-y-3">

                            <CollectionItem
                                label="Total No. of Books"
                                value="70,425"
                            />

                            <CollectionItem
                                label="No. of Text Books"
                                value="2,638"
                            />

                            <CollectionItem
                                label="No. of Reference Books"
                                value="67,787"
                            />

                            <CollectionItem
                                label="No. of Thesis"
                                value="5,990"
                            />

                            <CollectionItem
                                label="No. of Newspapers"
                                value="05"
                            />

                            <CollectionItem
                                label="E-Books"
                                value="1,60,000 (approx.)"
                            />

                            <CollectionItem
                                label="E-Journals"
                                value="4,500 (approx.)"
                            />

                        </div>


                        {/* Bottom highlight */}
                        <div className="mt-7 pt-6 border-t border-white/15">

                            <div className="flex items-center justify-between">

                                <span className="text-white/60 text-sm font-gill">
                                    Digital Resources
                                </span>

                                <span className="text-white font-gill">
                                    Available
                                </span>

                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</section>
{/* layout section end */}
  <section className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-6">

          

            <div className="space-y-5 text-[16px] leading-7 text-gray-700 text-justify">
                <h3 className="text-3xl md:text-4xl font-bold text-[var(--ink)] font-gill">Inflibnet</h3>
                <p className="text-justify text-lg font-gill">
                    Subscribed to INFLIBNET (Information and Library Network). INFLIBNET is involved in modernizing university libraries in India using the state-of-art technologies for the optimum utilization of information. INFLIBNET is set out to be a major player in promoting scholarly communication among academicians and researchers in India. Campus Faculties & Students can access E-books & E-journals through the following website.
                </p>
                {/* Button - Text ke just niche */}
                <div className="mt-4">
                    <a
                        href="https://www.inflibnet.ac.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-5 py-2.5 rounded-lg bg-[var(--saffron)] text-white font-gill text-sm hover:opacity-90 transition"
                    >
                        Visit Website
                    </a>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-[var(--ink)] font-gill">
    E-Consortium
</h3>

<ol className="list-decimal pl-6 space-y-4 text-justify text-gray-700 leading-7">

    <li className="text-lg font-gill">
        <strong className="text-lg font-gill">E-SHODHSINDHU:</strong>{" "}
        e-ShodhSindhu is an initiative of Consortium for Higher Education
        Electronics Resources by Ministry of Education.
    </li>

    <li className="text-lg font-gill">
        <strong>SHODHSHUDDHI (ORIGINAL):</strong>{" "}
        The Govt. of India was to provide Plagiarism Detection Software to
        all Indian Universities/Institutions including Central Universities,
        State Universities, Deemed to be Universities, Private Universities,
        Centrally Funded Technical Institutions (CFTIs), Institute of National
        importance (INIs), Inter University Centres of UGC (IUCs). The INFLIBNET
        Centre is a nodal agency to execute the project/initiative under the
        aegis of Ministry of Education.
    </li>

</ol>

 <h3 className="text-3xl md:text-4xl font-bold text-[var(--ink)] font-gill">
  Open Access Initiative
</h3>

<ol className="list-decimal pl-6 space-y-4 text-justify text-gray-700 leading-7">

    <li className="text-justify text-lg font-gill">
        <strong>SHODHGANGA:</strong>{" "}
       SHODHGANGA is a digital repository set-up for submission of electronic versions of theses and dissertations by students / research scholars in universities in India and make them available in open access to the world-wide academic community in response to the UGC Notification (Minimum Standards & Procedure for Award of M.Phil. / Ph.D Degree, Regulation, 2009 and amendment made in 2016) where-in the responsibility of maintaining the digital repository of Electronic Theses and Dissertations (ETDs) is assigned to the INFLIBNET Centre.
    </li>

    <li className="text-justify text-lg font-gill">
        <strong>SHODHGANGOTRI::</strong>{" "}
        Under this initiative, research scholars/research supervisors in universities could deposit an electronic version of approved synopsis submitted by research scholars to the universities for registering themselves under the PhD programme.
    </li>

</ol>
<h3 className="text-3xl md:text-4xl font-bold text-[var(--ink)]  font-gill">
 E-Content Development & Services
</h3>
                <p className="text-justify text-lg font-gill">
                  ILMS: ILMS i.e. INFLIBNET Learning Management Service is offered by the Information and Library Network Centre (An IUC of UGC) to the institutions of higher education across the country
                </p>
<section className="py-10 bg-[#f5f7fb]">
    <div className="max-w-6xl mx-auto px-6">

        {/* Heading */}
        <div className="mb-7">
            <span className="text-sm font-gill tracking-widest uppercase text-[#e21b1b]">
                Library Facilities
            </span>

            <h2 className="mt-2 text-3xl md:text-4xl font-bold text-[#08245c] font-gill">
                Infrastructure of the Library
            </h2>

            <div className="mt-3 w-20 h-1 bg-[#e21b1b] rounded-full"></div>
        </div>

        {/* Cards - Width Reduced */}
        <div className="max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* LEFT */}
            <div className="space-y-3">

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            Computers
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        10
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            PC with LAN Connectivity
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        02
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            Wi-Fi & LAN Connectivity
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        Yes
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] leading-5 font-gill">
                            Alice for Window and EGranthalaya Library Software
                            (Library Management Software)
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors font-gill">
                        Yes
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            Barcode Printer
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        01
                    </div>
                </div>

            </div>


            {/* RIGHT */}
            <div className="space-y-3">

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            Barcode Scanners
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        02
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            UPS
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        02
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            Mineral Water
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        01
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            CCTV Camera
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        20
                    </div>
                </div>

                <div className="group flex bg-white rounded-lg overflow-hidden
                    border border-gray-100 shadow-sm hover:shadow-md
                    hover:-translate-y-0.5 transition-all duration-300">

                    <div className="flex-1 p-4">
                        <p className="font-medium text-[#243b64] font-gill">
                            CCTV Displays
                        </p>
                    </div>

                    <div className="w-16 flex-shrink-0 flex items-center justify-center
                        bg-[#e21b1b] text-white font-bold italic
                        group-hover:bg-[#08245c] transition-colors">
                        02
                    </div>
                </div>

            </div>

        </div>
    </div>
</section>
<section className="py-12 bg-[#f5f7fb]">
    <div className="max-w-6xl mx-auto px-5">

        {/* ================= HEADING ================= */}
        <div className="mb-8">
            {/* <span className="text-sm font-gill tracking-[0.2em] uppercase text-[#e21b1b]">
                Digital Library
            </span> */}

            <h2 className="mt-2 text-3xl md:text-4xl font-bold text-[#08245c] font-gill">
                E-Resources
            </h2>

            <div className="mt-3 w-16 h-1 bg-[#e21b1b] rounded-full"></div>
        </div>


        {/* ================= RESOURCE CARD ================= */}
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">

            {/* Header */}
            <div className="hidden md:grid grid-cols-[1fr_130px_260px]
                bg-[#08245c] text-white px-6 py-4
                text-sm font-gill uppercase tracking-wide">

                <div className="text-lg font-gill">Source</div>
                <div className="text-lg font-gill">E-Books</div>
                <div className="text-lg font-gill">Website</div>
            </div>


            {/* ================= ROW 1 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition">

                <div>
                    <span className="md:hidden text-xs font-bold uppercase text-[#e21b1b] font-gill">
                        Source
                    </span>
                    <p className="font-medium text-[#243b64] text-lg font-gill">
                        SAGE
                    </p>
                </div>

                <div>
                    <span className="md:hidden text-xs font-bold uppercase text-[#e21b1b] font-gill">
                        E-Books
                    </span>
                    <p className="font-gill text-[#08245c] font-gill">
                        102
                    </p>
                </div>

                <div>
                    <a
                        href="https://search.sagepub.com/#_"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors duration-300"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 2 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        PEARSON
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        54
                    </p>
                </div>

                <div>
                    <a
                        href="https://about.proquest.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 3 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        ELSEVIER
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        121
                    </p>
                </div>

                <div>
                    <a
                        href="https://www.sciencedirect.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 4 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        GALE Database (Biotechnology)
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        08
                    </p>
                </div>

                <div>
                    <a
                        href="https://link.gale.com/apps/menu;JSESSIONID11_galeapps=29EFCDF4F45EE52BB155C1E2DC65B4B3.galeapps_202_98_238?userGroupName=kumaun&prodId=MENU"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 5 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        Art & Science Academic Publications (ASAP)
                        for Botany, Chemistry
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        07
                    </p>
                </div>

                <div>
                    <a
                        href="https://asapglobe.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 6 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        E-Book Collection (EBSCOhost) for Multidiscipline
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        1,60,000
                    </p>
                </div>

                <div>
                    <a
                        href="https://web.a.ebscohost.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 7 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        Himalaya eBooks (Commerce)
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        48
                    </p>
                </div>

                <div>
                    <a
                        href="https://ebooks.himpub.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>


            {/* ================= ROW 8 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                border-b border-gray-100
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        JSTOR, ISID AND Web of Science
                        (Collection of Journals)
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        03
                    </p>
                </div>

                <div className="flex flex-wrap gap-2">
                    <a
                        href="https://ess.inflibnet.ac.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-4 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition"
                    >
                        Visit Website 1
                    </a>

                    <a
                        href="https://access.clarivate.com/login?app=wos&alternative=true&goto=https:%2F%2Fwww.webofknowledge.com&shibShireURL=https:%2F%2Fwww.webofknowledge.com%2F%3Fauth%3DShibboleth&shibReturnURL=https:%2F%2Fwww.webofknowledge.com%2F&roaming=true"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-4 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition"
                    >
                        Visit Website 2
                    </a>
                </div>
            </div>


            {/* ================= ROW 9 ================= */}
            <div className="group grid grid-cols-1 md:grid-cols-[1fr_130px_260px]
                items-center gap-3 md:gap-0
                px-5 md:px-6 py-5
                hover:bg-[#fff7f7] transition text-lg font-gill">

                <div>
                    <p className="font-medium text-[#243b64]">
                        Springer Link 1700 Collection and Nature Journal
                        and Taylor and Francis Collection of Journals
                    </p>
                </div>

                <div>
                    <p className="font-gill text-[#08245c]">
                        —
                    </p>
                </div>

                <div>
                    <a
                        href="https://ess.inflibnet.ac.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex px-5 py-2.5 rounded-lg
                        bg-[#e21b1b] text-white text-sm font-gill
                        hover:bg-[#08245c] transition-colors"
                    >
                        Visit Website
                    </a>
                </div>
            </div>

        </div>
    </div>
</section>
                
                

            </div>
        </div>
    </section>
    <section className="py-14 bg-[#f5f7fb]">
    <div className="max-w-6xl mx-auto px-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-lg font-gill">

            {/* ================= ICT ENABLED SERVICES ================= */}
            <div className="group relative bg-white rounded-2xl p-6 md:p-8
                border border-gray-100 shadow-sm
                hover:shadow-xl transition-all duration-300 overflow-hidden">

                {/* Top Accent */}
                <div className="absolute top-0 left-0 w-full h-1.5 bg-[#e21b1b]"></div>

                {/* Decorative Circle */}
                <div className="absolute -right-10 -top-10 w-28 h-28
                    rounded-full bg-[#e21b1b]/5
                    group-hover:scale-125 transition-transform duration-500">
                </div>

                {/* Heading */}
                <div className="relative flex items-center gap-4 mb-7">

                    <div className="w-11 h-11 rounded-xl bg-[#e21b1b]
                        flex items-center justify-center
                        text-white font-bold text-lg shadow-md">
                        ICT
                    </div>

                    <div>
                        <h3 className="text-xl md:text-2xl font-bold text-[#08245c]">
                            ICT Enabled Library Services
                        </h3>

                        <div className="mt-2 w-12 h-1 bg-[#e21b1b] rounded-full"></div>
                    </div>

                </div>


                {/* List */}
                <div className="relative space-y-4">

                    {[
                        "Computerized issue/return of books.",
                        "ETDs Lab for e-journals Retrieval.",
                        "CCTV-cameras installed in the library.",
                        "Plagiarism detection software (URKUND).",
                        "Creating Institutional domain ids for the stakeholder of library (Google G-suite)",
                        "Remote access software such as Remote log by OCLC has been deployed for outside users."
                    ].map((item, index) => (

                        <div
                            key={index}
                            className="flex items-start gap-3 group/item"
                        >
                            <span className="flex-shrink-0 w-6 h-6 rounded-full
                                bg-[#fff1f1] text-[#e21b1b]
                                flex items-center justify-center
                                text-sm font-bold
                                group-hover/item:bg-[#e21b1b]
                                group-hover/item:text-white
                                transition-colors duration-300">
                                {index + 1}
                            </span>

                            <p className="text-[#40516f] leading-6 text-[15px]">
                                {item}
                            </p>
                        </div>

                    ))}

                </div>
            </div>


            {/* ================= SERVICES ================= */}
            <div className="group relative bg-white rounded-2xl p-6 md:p-8
                border border-gray-100 shadow-sm
                hover:shadow-xl transition-all duration-300 overflow-hidden">

                {/* Top Accent */}
                <div className="absolute top-0 left-0 w-full h-1.5 bg-[#08245c]"></div>

                {/* Decorative Circle */}
                <div className="absolute -right-10 -top-10 w-28 h-28
                    rounded-full bg-[#08245c]/5
                    group-hover:scale-125 transition-transform duration-500">
                </div>

                {/* Heading */}
                <div className="relative flex items-center gap-4 mb-7">

                    <div className="w-11 h-11 rounded-xl bg-[#08245c]
                        flex items-center justify-center
                        text-white font-bold text-lg shadow-md">
                        S
                    </div>

                    <div>
                        <h3 className="text-2xl md:text-3xl font-bold text-[#08245c]">
                            Services
                        </h3>

                        <div className="mt-2 w-12 h-1 bg-[#e21b1b] rounded-full"></div>
                    </div>

                </div>


                {/* Services Grid */}
                <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">

                    {[
                        "Circulation",
                        "Reference Service",
                        "Access to E-Books & E-Journals",
                        "Reading Room Facility",
                        "IP Remote Access",
                        "Thesis and Archives",
                        "Open Access System",
                        "Periodicals Service",
                        "Display of New Arrivals of Books",
                        "Reprographic Service",
                        "Display of New Arrivals of Journals",
                        "Inter Library loan service",
                        "Internet Facility for Students & Faculty"
                    ].map((item, index) => (

                        <div
                            key={index}
                            className="flex items-start gap-3 group/service"
                        >

                            <span className="mt-1 flex-shrink-0
                                text-[#e21b1b] font-bold text-lg
                                group-hover/service:translate-x-1
                                transition-transform duration-200">
                                ›
                            </span>

                            <p className="text-[#40516f] leading-6 text-[15px]">
                                {item}
                            </p>

                        </div>

                    ))}

                </div>
            </div>

        </div>
    </div>
</section>
  <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center text-lg font-gill">

            {/* IMAGE */}
          <div className="relative">
    <div className="absolute -left-5 -bottom-5 w-full h-full rounded-3xl bg-[var(--saffron)]/20" />

    <img
        src="/images/central-library3.jpeg"
        alt="Central Library"
        className="relative w-full h-auto object-contain rounded-3xl shadow-xl"
    />
</div>

            {/* CONTENT */}
            <div>
                <h2 className="uppercase tracking-[0.2em] text-3xl md:text-4xl  font-bold text-[var(--terracotta)] mb-3">
                 Library Automation and Digital Preservation
                </h2>

                {/* <h2 className="text-3xl md:text-4xl font-bold text-[var(--ink)] mb-6">
                   UNIVERSITY AT A GLANCE
                </h2> */}

                <p className="text-gray-600 leading-8 mb-5 text-justify">
                   Library automation entails the application of computer systems and data processing technologies to streamline core housekeeping operations—such as acquisitions, cataloguing, circulation, serials control, and reference services. At the Central Library of Kumaun University, Nainital, the integration of information and communication technology (ICT) has been central to modernizing academic support and enhancing user accessibility Over the years, the library has used different systems to keep up with user needs. In 2024, it switched to KOHA, a popular open-source library software, to run its daily operations. The staff is currently moving all catalogue data into KOHA to fully automate its collections. Alongside operational automation, the Central Library is actively engaged in digital preservation. To protect rare historical literature and expand access for the wider academic community.
                </p>

              
            </div>

        </div>
    </section>
   <section className="py-2 bg-[#f5f7fb] overflow-hidden">
    <div className="max-w-6xl mx-auto px-2">

        {/* Heading */}
        <div className="mb-4">
            {/* <span className="text-sm font-gill tracking-[0.2em] uppercase text-[#e21b1b]">
                Our Library
            </span> */}

            <h2 className="mt-2 text-3xl md:text-4xl font-bold text-[#08245c]  font-gill">
                Library Gallery
            </h2>

            <div className="mt-3 w-16 h-1 bg-[#e21b1b] rounded-full"></div>
        </div>

        {/* ================= MARQUEE ================= */}
        <div className="relative overflow-hidden">

            <div className="library-marquee">

                {/* FIRST SET */}
                <div className="library-track">

                    <div className="gallery-item">
                        <img
                            src="/images/central-library2.jpeg"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library3.jpeg"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library4.jpeg"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library5.jpeg"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library6.jpeg"
                            alt="Library"
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library7.jpeg"
                            alt="Library"
                        />
                    </div>
                     <div className="gallery-item">
                        <img
                            src="/images/central-library8.jpeg"
                            alt="Library"
                        />
                    </div>

                </div>


                {/* DUPLICATE SET - SEAMLESS LOOP */}
                <div className="library-track" aria-hidden="true">

                    <div className="gallery-item">
                        <img
                            src="/images/central-library2.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library3.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library4.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library5.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library6.jpeg"
                            alt=""
                        />
                    </div>

                    <div className="gallery-item">
                        <img
                            src="/images/central-library7.jpeg"
                            alt=""
                        />
                    </div>
                     <div className="gallery-item">
                        <img
                            src="/images/central-library8.jpeg"
                            alt=""
                        />
                    </div>

                </div>

            </div>

        </div>
    </div>


    {/* ================= MARQUEE CSS ================= */}
    <style>{`
        .library-marquee {
            display: flex;
            width: max-content;
            animation: libraryScroll 28s linear infinite;
        }

        .library-track {
            display: flex;
            gap: 24px;
            padding-right: 24px;
        }

        .gallery-item {
            width: 300px;
            height: 225px;
            flex-shrink: 0;
            overflow: hidden;
            border-radius: 12px;
            background: white;
            box-shadow: 0 6px 18px rgba(0,0,0,0.10);
            border: 1px solid rgba(8,36,92,0.08);
        }

        .gallery-item img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform 0.5s ease;
        }

        .gallery-item:hover img {
            transform: scale(1.06);
        }

        .library-marquee:hover {
            animation-play-state: paused;
        }

        @keyframes libraryScroll {
            from {
                transform: translateX(0);
            }

            to {
                transform: translateX(-50%);
            }
        }

        @media (max-width: 768px) {
            .gallery-item {
                width: 260px;
                height: 195px;
            }

            .library-track {
                gap: 16px;
                padding-right: 16px;
            }

            .library-marquee {
                animation-duration: 22s;
            }
        }
    `}</style>

</section>
    <Footer />

</div>

);

};




/* STAT COMPONENT */

const Stat = ({ icon, value, label }) => {
return (
<div className="p-6 text-center border-b md:border-b-0 md:border-r last:border-0">
    <div className="flex justify-center text-[var(--terracotta)] mb-3">
        {icon}
    </div>

    <div className="text-2xl font-bold text-[var(--ink)]">
        {value}
    </div>

    <div className="text-sm text-gray-500 mt-1">
        {label}
    </div>
</div>
);
};


/* HIGHLIGHT COMPONENT */

const Highlight = ({ title, text }) => {
return (
<div className="p-7 rounded-2xl border border-[var(--cream-deep)] bg-[var(--paper)] hover:shadow-lg transition">
    <h3 className="text-xl font-bold text-[var(--ink)] mb-3">
        {title}
    </h3>

    <p className="text-gray-600 leading-7">
        {text}
    </p>
</div>
);

};

export default CentralLibraryPage;
